export default __webpack_public_path__ + "static/media/github.4d31f3bc.jpg";